import { render, staticRenderFns } from "./Recognition.vue?vue&type=template&id=5892beb0&scoped=true&"
import script from "./Recognition.vue?vue&type=script&setup=true&lang=js&"
export * from "./Recognition.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Recognition.vue?vue&type=style&index=0&id=5892beb0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5892beb0",
  null
  
)

export default component.exports